import React, { useEffect, useState } from 'react';
import { FormControlLabel, Switch } from '@mui/material';
import { useLang } from '~/hooks/useLang';

interface FilterSwitchGroupLocationProps {
    readonly onCheckedChange: (value: boolean) => void;
    readonly checked: boolean;
    readonly disabled?: boolean
    readonly label: string;
}

export default function FilterSwitch({ onCheckedChange, checked, disabled, label }: FilterSwitchGroupLocationProps) {
    const { translate } = useLang();
    const [isChecked, setIsChecked] = useState<boolean>(false);

    useEffect(() => {
        setIsChecked(checked)
    }, [checked])


    return (
        <FormControlLabel
            label={translate(label)}
            control={
                <Switch
                    disabled={disabled}
                    checked={isChecked}
                    onChange={(_, checked) => {
                        setIsChecked(checked)
                        onCheckedChange(checked)
                    }}
                />
            }
        />
    )
}